import axiosInstance from './instance';

export const getArticles = (prompt) => axiosInstance.get(`/api/query?prompt=${prompt}_page`);

export const getTranscription = (data) => axiosInstance.post('/api/transcription', data);
